import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M26.93,3.38a1.56,1.56,0,0,0-1.36-.85H6.43a1.56,1.56,0,0,0-1.36.85A1.78,1.78,0,0,0,5.08,5l7.54,12.76v12l6.76-2.71V17.79L26.94,5A1.76,1.76,0,0,0,26.93,3.38Z' })
));